











import { View } from 'client-website-ts-library/plugins';
import { Component } from 'vue-property-decorator';

import Form from '../components/Forms/Form.vue';

@Component({
  components: {
    Form,
  },
})
export default class RentalAppraisal extends View {

}
